import React from 'react';
// import "./contact.css";


import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { Link } from "react-router-dom";


function Contact() {

    const popover = (
        <Popover id="popover-basic" className="rounded-0">
            <Popover.Header as="h2" className="font-bold text-sm">HELP CENTER</Popover.Header>
            <Popover.Body className="rounded-0 text-xs">
                WELCOME <strong>SIR,</strong> HOW CAN HELP YOU?
            </Popover.Body>
        </Popover>
    );


    return (
        <>
            <div className="  px-8  justify-center  h-auto container ">
                <h1 className='uppercase text-xl font-semibold justify-center text-center  pt-28 '>Contact Us</h1>
                <hr className='my-2 text-[#d3d3d3] outline-dotted' />
                <div className="section2 ">
                    <div className="col-md-6 pt-4  ">
                        {/* <!-- Form Store Data in Email --> */}
                        <form action="https://formsubmit.co/musharafali494@gmail.com" method="POST">
                            <div id="first_div" className='w-100  justify-center  px-6'>
                                <div className="py-1">
                                    <label>Full Name:</label>
                                    <input type="name" name="Full Name" placeholder="Enter your Name" class="border w-100 py-1  m-0 focus:outline-none px-2" />
                                </div>
                                <div className="py-1">
                                    <label>Email Address:</label>
                                    <input type="email" name="Email Address" id="email" placeholder="Enter your Email" class="border w-100 py-1 p-0 m-0 focus:outline-none px-2" /></div>
                                <div className="py-1">
                                    <label>Phone Number:</label>
                                    <input type="text" name="Phone Number" placeholder="Enter your Phone Number" class="border w-100 py-1 p-0 m-0 focus:outline-none px-2" />
                                </div>
                                <div className="py-1">
                                    <label>Company or Organization Name:</label>
                                    <input type="text" name="Company or Organization Name" placeholder="Enter a Company or Organization Name" class="border w-100 py-1 p-0 m-0 focus:outline-none px-2" />
                                </div>
                                <label class="font-semibold" name="Project Description:">Project Description:</label><br />
                                <textarea name="
                                        Project Description" placeholder="Enter Your Project Description" class="border focus:outline-none px-1 w-100 h-40"></textarea><br />

                                <div className="py-1">
                                    <label>Budget Range:</label>
                                    <input type="text" name="Budget Range:" placeholder="Enter a Price" class="border w-100 py-1 p-0 m-0 focus:outline-none px-2" />
                                </div>
                                <div className="py-1">
                                    <label>Timeline:</label>
                                    <input type="text" name="Timeline:" placeholder="Enter a timeline" class="border w-100 py-1 p-0 m-0 focus:outline-none px-2" />
                                </div>

                                <div className="py-2">
                                    <label id="head2" name="What would you like to see improved ?(check all that apply)" className='font-semibold fs-6 py-1'>Are you Interested in?</label>
                                    <div id="Second_div">
                                        <input type="checkbox" name="Web Developement" class="larger" /><label className='px-2'> Web Developement </label><br />
                                        <input type="checkbox" name="App Developement" class="larger" /><label className='px-2'> App Developement -
                                        </label><br />
                                        <input type="checkbox" name="AI/ML - Intern" class="larger" /><label className='px-2'> AI/ML </label><br />
                                        <input type="checkbox" name="Flutter app Development" class="larger" /><label className='px-2'>Flutter Developer
                                        </label><br />
                                        <input type="checkbox" name="Graphic Designing" class="larger" /><label className='px-2'>Graphic Designing
                                        </label><br />
                                        <input type="checkbox" name="Video Editing" class="larger" /><label className='px-2'> Video Editing
                                        </label><br />
                                        <input type="checkbox" name="Others" class="larger" /><label className='px-2'> Others</label></div>
                                    <div className="py-2">

                                        <label class="font-semibold" name="Write a Additional Comments or Requirements">Additional Comments or Requirements: </label><br />
                                        <textarea name="Massage/Comment" placeholder="Write a massage here..." class="border focus:outline-none px-1 w-100 h-40"></textarea><br />
                                        <input type="hidden" name="_url" value="https://yourdomain.co/contact.html" />
                                    </div>
                                    <button className="btn uppercase text-white duration-600 mt-4  mx-2 border-0 rounded-none bg-[#ee2da4] text-sm  px-6 py-2 font-bold" name="Submit">
                                        <h3>SUBMIT</h3>
                                    </button><br /><br />
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="col-md-6  pt-20 justify-center text-center">   <OverlayTrigger trigger="click" placement="right" overlay={popover}>
                        <Button className="border btn rounded-0 bg-black text-white mt-4">
                            ACCESS
                        </Button>
                    </OverlayTrigger>
                        <h4 className="text-sm font-semibold pb-10 mt-2 ">CUSTOMER SERVICE</h4>
                        <p className="text-xs">
                            CHAT
                            <br />
                            Scheule:24/7
                        </p>
                        <br />
                        <p className="text-sm font-semibold pb-2">SOCIAL MEDIA</p>
                        <div className="">
                            <Link to="https://www.facebook.com/mscubetechs">
                                <p className="text-xs pb-1">
                                    <span className="font-semibold">FACEBOOK</span>: @mscubetechs
                                </p></Link>
                            <Link to="https://twitter.com/mscubetech" >
                                <p className="text-xs  pb-1">
                                    <span className="font-semibold">TWITTER</span>: @mscubetech
                                </p>
                            </Link>
                            <Link to="https://www.youtube.com/@mscubetech" >
                                <p className="text-xs  pb-1">
                                    <span className="font-semibold">YOUTUBE</span>: @mscubetech
                                </p>
                            </Link>
                            <Link to="https://instagram.com/mscubetechs" >
                                <p className="text-xs pb-1">
                                    <span className="font-semibold">INSTAGRAM</span>: @mscubetech
                                </p>
                            </Link>
                        </div>
                    </div>
                    {/* <div className="col-md-6">
                         
                            {/* <button className="border btn rounded-0 bg-black text-white mt-4">ACCESS</button> */}
                    {/* </div> */}
                </div>
            </div>
        </>
    );
}

export default Contact;
